const a = {
  model: {
    title: 'Model',
    fold: 'modelFold',
    default: true
  },
  process: {
    title: 'Process',
    fold: 'processFold',
    default: true
  },
  view: {
    title: 'View',
    fold: 'viewFold',
    default: true
  }
}
export default a
